export class DetalleIngresoDucto {
  codigoTanque: string;
  volumen: number;
  volumen15: number;
  aforadorInicial: number;
  aforadorFinal: number;
}
